export interface IDateFilter {
  start: string;
  end: string;
}
